import React from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { theme } from '../../theme';

export const ScreenShareStopIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      style={{
        fontSize: 40,
        ...props.style,
      }}
      width="40px"
      height="40px"
      viewBox="0 0 40 40"
    >
      <g
        id="Ui/Elements/Icons/Screenshare/Stop/Black"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M20.617,21.004 L26.9503546,27.329078 C26.9841466,27.3618828 27.0145592,27.3979977 27.0411348,27.4368794 C27.0524823,27.4539007 27.0695035,27.470922 27.0695035,27.4879433 C27.0831924,27.5108316 27.0955073,27.5345141 27.106383,27.5588652 C27.1152099,27.5820834 27.1227858,27.605758 27.129078,27.6297872 C27.1489362,27.6496454 27.1489362,27.6695035 27.1489362,27.6921986 C27.1677348,27.785827 27.1677348,27.8822581 27.1489362,27.9758865 C27.129078,27.9985816 27.129078,28.0184397 27.129078,28.0382979 C27.1227806,28.0623256 27.1152048,28.0859999 27.106383,28.1092199 C27.0919103,28.1348177 27.0758012,28.1594552 27.058156,28.1829787 C27.0468085,28.2 27.0297872,28.2170213 27.0297872,28.2340426 C26.9952442,28.2856594 26.9541721,28.3324227 26.9076881,28.3732155 L26.8340426,28.4297872 L26.7829787,28.458156 L26.7480441,28.4776079 L26.7480441,28.4776079 L26.7120567,28.4950355 L26.6411348,28.5177305 L26.5787234,28.5347518 L26.5092199,28.5381657 L26.5092199,28.5381657 L26.4397163,28.5347518 L13.4042553,28.5347518 L13.3276596,28.5120567 L13.270922,28.4950355 L13.2305209,28.4750371 L13.2305209,28.4750371 L13.1914894,28.4524823 L13.177,28.444 L20.617,21.004 Z M20,22.3900709 L15.2595745,27.1304965 L24.7375887,27.1304965 L20,22.3900709 Z M31.1489362,11 C31.5828096,11 31.9408527,11.3246682 31.993369,11.7443082 L32,11.8510638 L32,24.4695035 C32,24.903377 31.6753318,25.2614201 31.2556918,25.3139364 L31.1489362,25.3205674 L28.0652482,25.3205674 C27.6735569,25.3205674 27.3560284,25.0030388 27.3560284,24.6113475 C27.3560284,24.2522971 27.6228405,23.9555641 27.9690113,23.908602 L28.0652482,23.9021277 L30.5815603,23.9021277 L30.5815603,12.4184397 L29.204,12.418 L30.622,11 L31.1489362,11 Z M26.378,11 L24.96,12.418 L9.41843972,12.4184397 L9.41843972,23.9021277 L11.9347518,23.9021277 C12.3264431,23.9021277 12.6439716,24.2196562 12.6439716,24.6113475 C12.6439716,24.6588898 12.6392937,24.7053394 12.630373,24.7502613 L12.0732113,25.3070588 C12.0592795,25.3098159 12.045201,25.312165 12.0309887,25.314093 L11.9347518,25.3205674 L8.85106383,25.3205674 C8.41719038,25.3205674 8.05914725,24.9958991 8.006631,24.5762592 L8,24.4695035 L8,11.8510638 C8,11.4171904 8.32466824,11.0591473 8.74430819,11.006631 L8.85106383,11 L26.378,11 Z"
          id="Combined-Shape"
          fill={props.htmlColor || theme.colors.greyScale.white}
          fillRule="nonzero"
        ></path>
        <rect
          id="Rectangle"
          fill={props.htmlColor || theme.colors.greyScale.white}
          transform="translate(20.000000, 19.500000) rotate(-45.000000) translate(-20.000000, -19.500000) "
          x="6"
          y="19"
          width="28"
          height="1"
        ></rect>
      </g>
    </SvgIcon>
  );
};
